import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { MessageSquareText, CheckCircle2, AlertCircle } from "lucide-react";

export function SmsSettings() {
  const [cfg, setCfg] = useState(null);
  const [form, setForm] = useState({ api_key: "", sender: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/admin/sms/config").then(({ data }) => { setCfg(data); setForm({ api_key: "", sender: data.sender || "LOrnePark" }); });
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/admin/sms/config", form);
      setCfg(data); setForm((f) => ({ ...f, api_key: "" }));
      toast.success(data.configured ? "Brevo configuré — l'envoi de SMS est actif" : "Enregistré (configuration incomplète)");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  if (!cfg) return null;
  return (
    <div className="rounded-2xl bg-white border border-border p-5" data-testid="sms-settings">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <h2 className="font-serif text-2xl text-olive flex items-center gap-2"><MessageSquareText className="w-5 h-5 text-rose-brand" /> Envoi de SMS (Brevo)</h2>
          <p className="text-sm text-muted-foreground mt-1">
            1. Créez un compte sur <a href="https://app.brevo.com" target="_blank" rel="noreferrer" className="text-rose-brand underline">brevo.com</a> et achetez des crédits SMS.<br />
            2. Menu <strong>SMTP &amp; API → Clés API → Générer</strong> : copiez la clé (commence par <code>xkeysib-</code>).<br />
            3. <strong>Paramètres → SMS → Nom d'expéditeur</strong> : déclarez votre marque (3 à 11 lettres/chiffres, ex. « LOrnePark »).
          </p>
        </div>
        <span className={`inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1 rounded-full ${cfg.configured ? "bg-olive text-white" : "bg-rosebrand-pale text-rose-brand"}`} data-testid="sms-status">
          {cfg.configured ? <><CheckCircle2 className="w-3.5 h-3.5" /> Actif</> : <><AlertCircle className="w-3.5 h-3.5" /> Non configuré</>}
        </span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-4">
        <div><Label className="text-xs">Clé API Brevo {cfg.api_key_masked && <span className="text-muted-foreground">(actuelle : {cfg.api_key_masked})</span>}</Label><Input type="password" value={form.api_key} onChange={(e) => setForm({ ...form, api_key: e.target.value })} placeholder={cfg.api_key_masked ? "Laisser vide pour conserver" : "xkeysib-…"} data-testid="sms-key-input" /></div>
        <div><Label className="text-xs">Nom d'expéditeur (3–11 lettres/chiffres)</Label><Input value={form.sender} maxLength={11} onChange={(e) => setForm({ ...form, sender: e.target.value.replace(/[^A-Za-z0-9]/g, "") })} placeholder="LOrnePark" data-testid="sms-sender-input" /></div>
      </div>
      <Button onClick={save} disabled={busy} className="mt-4 bg-olive text-white" data-testid="sms-save-button">{busy ? "..." : "Enregistrer"}</Button>
    </div>
  );
}
